import script from "./SearchInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchInput.vue?vue&type=script&setup=true&lang=ts"

import "./SearchInput.vue?vue&type=style&index=0&id=1b16b288&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b16b288"]])

export default __exports__